// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4173":"0b2b55a5","4224":"bde7a865","7352":"191a6072","8847":"12de4733"}[chunkId] + ".css";
};